@if (!isLoading) {
    <div class="upcoming-container">
        @if (showNextOverhead) {
            <app-upcoming-interviews-next [interviewerId]="interviewerId"></app-upcoming-interviews-next>
        }
        @if (showThisWeek) {
            <app-upcoming-interviews-week [filterCountry]="filterCountry" [next]="next" [thisWeek]="thisWeek" [interviewerId]="interviewerId" [showTable]="showTable" [filter]="filter" [compact]="compact" [showThisWeek]="showThisWeek" [showTime]="showTime" [title]="title"></app-upcoming-interviews-week>
        }
    </div>
} @else {
    <div class="loading">
        @if (title) {
            <h3>{{title}}</h3>
        }
        <div class="load_container">
            <app-cf-loader></app-cf-loader>
        </div>
    </div>
}